import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bd793ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "JobBoardCard__Background" }, null, -1))
const _hoisted_2 = { class: "JobBoardCard__Inner" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "JobBoardCard__Recruiter" }
const _hoisted_7 = {
  key: 0,
  class: "round"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "JobBoardCard__Applied",
  viewBox: "0 0 32 32"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-applied" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "JobBoardCard__Applied",
  viewBox: "0 0 32 32"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/job-board/${_ctx.job.slug}`,
    class: _normalizeClass(["JobBoardCard", { 'current': _ctx.selectedJob?.slug === _ctx.job.slug }])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.job.title), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.job.restaurant), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.job.location), 1),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.job.recruiter_img)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.job.recruiter_img,
                  alt: _ctx.job.recruiter
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("dashboard.posted_by")) + " " + _toDisplayString(_ctx.job.recruiter), 1),
          _hoisted_10,
          _createVNode(_Transition, { name: "applied" }, {
            default: _withCtx(() => [
              (_ctx.job.applied)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                : (_openBlock(), _createElementBlock("svg", _hoisted_14))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}